import { Title } from 'library/styles/text';
import { List, Container } from './styles';
import Item from './item';

const Categories = ({ data = [], selectedData = [], onChange }) => (
  <Container>
    <Title>Category settings</Title>
    <List>
      {data.map((props) => (
        <Item
          {...props}
          key={props.id}
          onChange={onChange}
          value={selectedData.includes(props.id)}
        />
      ))}
    </List>
  </Container>
);

export default Categories;
